import { IMapViewData, Interaction, defaultInteraction } from 'sdi/map';
import { ILayerInfo, Inspire, FeatureCollection } from 'sdi/source';
import { Collection } from 'sdi/util';
import { LegendSelector, SymbologySelector } from '../queries/map';
import { Coordinate } from 'ol/coordinate';

declare module 'sdi/shape' {
    export interface IShape {
        'port/map/view': IMapViewData;
        'port/map/interaction': Interaction;
        'data/layer-infos': ILayerInfo[];
        'data/metadatas': Inspire[];
        'data/layers': Collection<FeatureCollection>;
        'data/baselayer/select': string;
        'map/symbology': SymbologySelector;
        'map/legend/symbology': LegendSelector;
    }
}

export const DEFAULT_CENTER: Coordinate = [158885, 150690];
export const DEFAULT_CENTER_3857: Coordinate = [450000, 6600000];
export const defaultMapView = (): IMapViewData => ({
    dirty: 'geo',
    srs: 'EPSG:3857',
    center: DEFAULT_CENTER_3857,
    rotation: 0,
    zoom: 6,
    feature: null,
    extent: null,
});

const defaultBaseLayer = 'gray-ign';

export const defaultMapState = () => ({
    'port/map/view': defaultMapView(),
    'port/map/interaction': defaultInteraction(),
    'data/layer-infos': [],
    'data/metadatas': [],
    'data/layers': {},
    'data/baselayer/select': defaultBaseLayer,
    'map/symbology': 'typology' as SymbologySelector,
    'map/legend/symbology': 'typology' as LegendSelector,
});
